import React from 'react';
import cn from 'classnames';
import { Col, Row } from 'festo-react-ui-kit';
import { useLocation, useNavigate, useParams } from 'react-router';

import useTranslation from '../../features/translation/hooks/useTranslation';

import Application from '../../components/Application/Application';
import Graphic from '../../components/Graphic/Graphic';
import Parameters from '../../components/Parameters/Parameters';
import { useAppSelector } from '../../app/hooks';
import { isFiltersLoading } from '../../features/filter/filterSlice';
import { LoadingIndicator } from '@festo-ui/react';
import { econdaClickEvent } from '../../Econda';
import './Section.scss';
import useHeadline from '../../components/Headline/hooks/useHeadline';
import useFoxPresence from '../../components/Headline/hooks/useFoxPresence';

enum TranslationKeys {
  APP_PARAMETERS = 'appParameters',
}

const Section: React.FunctionComponent = () => {
  const { hasFoXHeadline } = useFoxPresence();
  const { headlineName } = useHeadline();
  const { pathname } = useLocation();
  const isLoading = useAppSelector(isFiltersLoading);
  const navigate = useNavigate();
  const t = useTranslation();
  const url = useParams();

  const handleNextStep = () => {
    navigate(`${pathname}/results`);
    econdaClickEvent(pathname, `${url.sectionName}`, 'Show Results button', 'click');
  };

  return (
    <div className="ems-entry-page-detail container-fluid">
      <p className="fr-heading entry-page-title">
        {hasFoXHeadline ? t(headlineName) : t(TranslationKeys.APP_PARAMETERS)}
      </p>
      {isLoading === 'pending' && <LoadingIndicator size="large" />}
      {(isLoading === 'idle' || isLoading === 'success') && (
        <Application
          className={cn('ems-defined-application', `ems-defined-application--${'runUpAndContinuousOperation'}`)}
          onNextClick={handleNextStep}
        >
          <Row>
            <Col xs={12} sm={6} md={4} lg={3}>
              <Graphic />
            </Col>
            <Col xs={12} md={8} lg={9} className="ems-defined-application__main-section">
              <Parameters />
            </Col>
          </Row>
        </Application>
      )}
      {isLoading === 'error' && <h3>Couldn't fetch filters, try again later.</h3>}
    </div>
  );
};

export default Section;
